import './App.css';
import './css/rain.css';
import './css/snow.scss';
import { React, useEffect, useState, useRef, useContext } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import navValues from './helpers/navValues';
import classnames from "classnames";
import { useTranslation } from 'react-i18next';
import { CurrentUserProvider } from './helpers/UserContext';
import App1 from './components/App1';
import App2 from './components/App2';
import App3 from './components/App3';
import AppNow from './components/AppNow';
import AppExternal from './components/AppExternal';
import {getMainData, getBackupData, getActivitiesData} from './helpers/Utils';
import Sidebar from './components/Sidebar';
import configJson from "./02wsconfig.json";
import {ConfigProvider} from "./helpers/useConfig";
import ExternalContext from "./helpers/ExternalContext";
import logo from './res/logo.svg';
import {useConfig} from "./helpers/useConfig";
import AutoplayPlayer from './components/AutoplayPlayer';

function App({layout, src}) {
  
  const [isLoading, setIsLoading] = useState(true);
  const [layoutConfig, setLayout] = useState('current');
  const [langCode, setLangCode] = useState(1);
  const [json, setJson] = useState([]);
  const [activities, setActivities] = useState(false);
  const [current, setCurrent] = useState([]);
  const [states, setStates] = useState([]);
  const [thisMonth, setThisMonth] = useState([]);
  const [nav, setNav] = useState(navValues.home);
  const { t, i18n } = useTranslation();
  const {configData} = useConfig();

  function setClassesToRoot (classes)  {
     console.log('setClassesToRoot:', classes);
     let root = document.getElementById("root");
    
    if (classes !== "")
       root.classList.add(classes);
  }

  const counter = useRef(0);
  var target = useContext(ExternalContext);

   useEffect(() =>{
      const fetchJson = async () => {

      getMainData()
       .then(json => {
          const current = json.jws.current;
          const states = json.jws.states;
          const thisMonth = json.jws.thisMonth;
           setJson(json);
          setThisMonth(thisMonth);
          setStates(states);
          setCurrent(current);
          importConfigData();
          setIsLoading(false);
       }
      )
      .catch(error => {
        console.error("getting backup data:", error);
        const json = getBackupData()
        .then(json => {
          const current = json.jws.current;
          const states = json.jws.states;
          const thisMonth = json.jws.thisMonth;
          setJson(json);
          setThisMonth(thisMonth);
          setStates(states);
          setCurrent(current);
          importConfigData();
          setIsLoading(false);
       })
       .catch(error => {
        console.error("error on backup data:", error);
        
       })
      }
      );

      getActivitiesData()
      .then(activities =>
      {
         setActivities({activities});
      }
      )
      .catch(error => {
        console.error("getting activities:", error);
      }
      )
      counter.current++;
    
    };
   fetchJson();
    const timer = setInterval(() => {
      fetchJson();
    }, 60000);
  }, [])

function isLayout(p_layout){
  if (layout == '')
      return (p_layout == layoutConfig);
  return (layout == p_layout);
}

function isRoot() {
  return false;
}


 const importConfigData = () => {
   
   console.log('configData:', configData);
    setLayout(layout == '' ? configData.layout : layout);
    console.log('layout=' + layout + " configData.layout=" + configData.layout);
    setClassesToRoot(configData.lang == 1 ? "rtl" : "");
    
 }


  const cssClasses = classnames ({
    
    
    snow: (states.issnowing  === '1'||states.issnowing  === 'true'),
    rain: (states.israining  === '1'||states.issnowing  === 'true'),
    night: (current.islight  === ''||current.islight  === 'false'),
    dust: (current.isdusty === 'true'),
    cold: (current.temp < 7),
    hot: (current.temp > 32),
    windy: (current.iswindy === 'true'),
    sunset: (current.issunset === 'true'),
    sunrise: (current.issunrise === 'true'),
    cloudy: (current.cloudiness >= 6),
    partlycloudy: (current.cloudiness > 2 && current.cloudiness < 6),
    fewclouds: (current.cloudiness > 0 && current.cloudiness <= 2),
    pride:false,
  
  });

 
 if (isLayout(navValues.current) || isLayout('')){
  return (
    isLoading ?
    <div className="splash"><img src={logo} width="400" alt="logo" className="rounded mx-auto d-block img-fluid" ></img></div>  :
    <GoogleOAuthProvider clientId="1056747824588-jkeqcbv1b2i8pr671vsts93dq81f8nu2.apps.googleusercontent.com">
    <CurrentUserProvider>
      <Sidebar layout={navValues.current} cssClasses={cssClasses}/>
     <App1 json={json} cssClasses={cssClasses} activities_json={activities} />
     </CurrentUserProvider>
     </GoogleOAuthProvider>
    
    
 )} else  if (isLayout(navValues.forecast24)) {
    return (
      isLoading ?
      <div className="splash"><img src={logo} width="400" alt="logo" className="rounded mx-auto d-block img-fluid" ></img></div>  :
      <GoogleOAuthProvider clientId="1056747824588-jkeqcbv1b2i8pr671vsts93dq81f8nu2.apps.googleusercontent.com">
     <CurrentUserProvider>
        <Sidebar layout={navValues.forecast24} cssClasses={cssClasses}/>
        <App2 json={json} cssClasses={cssClasses}  activities_json={activities} />
      </CurrentUserProvider>
     </GoogleOAuthProvider> 
      
   )}  else  if (isLayout(navValues.NextDays)){
    return (
      isLoading ?
      <div className="splash"><img src={logo} width="400" alt="logo" className="rounded mx-auto d-block img-fluid" ></img></div>  :
      <GoogleOAuthProvider clientId="1056747824588-jkeqcbv1b2i8pr671vsts93dq81f8nu2.apps.googleusercontent.com">
     <CurrentUserProvider>
        <Sidebar layout={navValues.NextDays} cssClasses={cssClasses}/>
        <App3 json={json} cssClasses={cssClasses}  activities_json={activities}/>
        </CurrentUserProvider> 
        </GoogleOAuthProvider> 
      
    )}  else  if (isLayout(navValues.External)) {
    return (
      isLoading ?
      <div className="splash"><img src={logo} width="400" alt="logo" className="rounded mx-auto d-block img-fluid" ></img></div>  :
      <GoogleOAuthProvider clientId="1056747824588-jkeqcbv1b2i8pr671vsts93dq81f8nu2.apps.googleusercontent.com">
      <ExternalContext.Provider value={target}>
      <CurrentUserProvider>
        <Sidebar layout={navValues.External} cssClasses={cssClasses}/>
        <AppExternal src={src} json={json} cssClasses={cssClasses}  activities_json={activities}/>
        </CurrentUserProvider>
      </ExternalContext.Provider>
      </GoogleOAuthProvider> 
      
    )} else  if (isLayout(navValues.now)) {
      return (
        isLoading ?
        <div className="splash"><img src={logo} width="400" alt="logo" className="rounded mx-auto d-block img-fluid" ></img></div>  :
        <GoogleOAuthProvider clientId="1056747824588-jkeqcbv1b2i8pr671vsts93dq81f8nu2.apps.googleusercontent.com">
        <CurrentUserProvider>
          <Sidebar layout={navValues.now} cssClasses={cssClasses}/>
          <AppNow json={json} cssClasses={cssClasses}  activities_json={activities}/>
        </CurrentUserProvider>
        </GoogleOAuthProvider> 
        
     )};
  
}

export default App;

